export default __webpack_public_path__ + "static/media/storageUnit1-beforeA-1920w.61ec114b.webp";